export enum UpdateStatus {
    UP_TO_DATE = "UP_TO_DATE",
    DUE_TO_UPDATE = "DUE_TO_UPDATE",
    NEVER_UPDATED = "NEVER_UPDATED",
}
